import { PagedResponse } from './Pagination';

// Tenants Parking equals bulk rental from BE
export type TenantsParkingData = {
    uuid: string;
    start_date: string;
    end_date: string | null;
    description: string | null;
    sub_id: string | null;
    spot: number;
    slot_count: number;
    price_per_slot: number;
    active_rentals: number;
    invoice_amount: string | null;
    invoice_url: string | null;
    invoice_status: string | null;
    invoice_pdf_url: string | null;
    overdue: boolean;
    tenant_uuid: string | null;
    owner: {
        accountType: string | null;
        dob: string | null;
        email: string | null;
        phone: string | null;
        phone_country_code: string | null;
        isEnforcer: boolean;
        enforcer: string | null;
        spaceforce_username: string | null;
        spaceforce_admin: boolean;
        pk: number;
        account_credit: number;
        customer_id: string | null;
    };
};

export enum TenantInvoiceStatusFilter {
    All = 'all',
    Open = 'open',
    Overdue = 'overdue',
    Paid = 'paid',
}

export type TenantInvoice = {
    id: number;
    display_name: string;
    amount_due: number;
    amount_remaining: number;
    due_date: string | null;
    created_at: string;
    paid_at: string | null;
    status: string | null;
    hosted_invoice_url: string | null;
    invoice_pdf: string | null;
    is_overdue: boolean;
};

export type TenantInvoicesResponse = PagedResponse<TenantInvoice> & {
    summary: {
        open_invoices: number;
        overdue_invoices: number;
        overdue_amount: number;
    };
    overdue_notice: {
        count: number;
        amount_remaining: number;
    };
};
